import { ArrowClockwiseIcon, CopyIcon, TrashIcon } from "@phosphor-icons/react";
import {
  Button,
  ButtonProps,
  Popover,
  PopoverProps,
  Space,
  Tooltip,
} from "antd";
import styled from "styled-components";

export const ItemControlsPopover = ({
  onDelete,
  onDuplicate,
  onRotate,
  deleteButtonTooltip,
  duplicateButtonTooltip,
  rotateButtonTooltip,
  canDuplicate = true,
  canDelete = true,
  canRotate = true,
  ...props
}: {
  onDelete?: (event: React.MouseEvent<HTMLElement>) => void;
  onDuplicate?: (event: React.MouseEvent<HTMLElement>) => void;
  onRotate?: (event: React.MouseEvent<HTMLElement>) => void;
  deleteButtonTooltip?: string;
  duplicateButtonTooltip?: string;
  rotateButtonTooltip?: string;
  canDuplicate?: boolean;
  canDelete?: boolean;
  canRotate?: boolean;
} & PopoverProps) => {
  const controlProps: ButtonProps = {
    type: "text",
    size: "small",
    style: { background: "none" },
  };
  const controls = [
    {
      id: "rotate-button",
      icon: <ArrowClockwiseIcon weight="bold" size={20} />,
      onClick: onRotate,
      tooltip: rotateButtonTooltip,
      available: canRotate,
    },
    {
      id: "duplicate-button",
      icon: <CopyIcon weight="bold" size={20} />,
      onClick: onDuplicate,
      tooltip: duplicateButtonTooltip,
      available: canDuplicate,
    },
    {
      id: "delete-button",
      icon: <TrashIcon weight="bold" size={20} />,
      onClick: onDelete,
      tooltip: deleteButtonTooltip,
      available: canDelete,
      danger: true,
    },
  ];

  return (
    <StyledPopover
      arrow={true}
      getPopupContainer={(triggerNode) =>
        triggerNode.closest<HTMLElement>(".video-editor-scene") ?? document.body
      }
      content={
        <Space data-interactive>
          {controls.map((control) => {
            if (!control.available) return null;
            return (
              <Tooltip title={control.tooltip} key={control.id}>
                <Button
                  {...controlProps}
                  id={control.id}
                  icon={control.icon}
                  onMouseDown={(e) => {
                    e.stopPropagation();
                  }}
                  onClick={control.onClick}
                  danger={control.danger}
                />
              </Tooltip>
            );
          })}
        </Space>
      }
      styles={{
        body: {
          padding: "2px",
          paddingTop: "5px",
          backgroundColor: "rgba(255, 255, 255, 0.9) !important",
        },
        root: {
          // Above the editor header (z-index 999) so the controls aren't
          // hidden behind it when an item sits near the top of the viewport.
          zIndex: 1000,
        },
      }}
      {...props}
    >
      {props.children}
    </StyledPopover>
  );
};

const StyledPopover = styled(Popover)`
  .ant-popover-arrow {
    opacity: 0.9;
  }
`;
